const state = {
  unreadCount: { total: 0, unread: {}, expired: {} },
};

const mutations = {
  setUnreadCount(state, val) {
    state.unreadCount = val;
  },
};

const actions = {};

const getters = {
  unreadCount: state => state.unreadCount,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
